import { Card, Text, Table, Badge, Group, ActionIcon, Button } from '@mantine/core'
import { IconExternalLink, IconScale, IconTrash } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import type { Service } from '@/types'
import { formatDistanceToNow } from 'date-fns'

interface ServiceListProps {
  services: Service[]
}

export function ServiceList({ services }: ServiceListProps) {
  const navigate = useNavigate()

  const getServiceStatus = (service: Service) => {
    // In real implementation, would check actual task status
    return 'running'
  }

  const rows = services.map((service) => (
    <Table.Tr key={service.ID}>
      <Table.Td>
        <Text fw={500}>{service.Spec.Name}</Text>
      </Table.Td>
      <Table.Td>
        <Badge color={getServiceStatus(service) === 'running' ? 'green' : 'red'} variant="dot">
          {getServiceStatus(service)}
        </Badge>
      </Table.Td>
      <Table.Td>
        <Group gap="xs">
          <Text size="sm">
            {service.Spec.Mode.Replicated?.Replicas || 0}
          </Text>
          <Text size="sm" c="dimmed">
            replicas
          </Text>
        </Group>
      </Table.Td>
      <Table.Td>
        <Text size="sm" c="dimmed">
          {formatDistanceToNow(new Date(service.UpdatedAt), { addSuffix: true })}
        </Text>
      </Table.Td>
      <Table.Td>
        <Group gap="xs" justify="flex-end">
          <ActionIcon
            variant="subtle"
            onClick={() => navigate(`/services/${service.ID}`)}
            title="View details"
          >
            <IconExternalLink size={16} />
          </ActionIcon>
          <ActionIcon
            variant="subtle"
            color="blue"
            title="Scale service"
          >
            <IconScale size={16} />
          </ActionIcon>
          <ActionIcon
            variant="subtle"
            color="red"
            title="Delete service"
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <Card shadow="sm" p="lg" radius="md">
      <Group justify="space-between" mb="md">
        <Text size="lg" fw={600}>
          Services
        </Text>
        <Button
          variant="subtle"
          size="sm"
          onClick={() => navigate('/services')}
        >
          View all
        </Button>
      </Group>

      <Table horizontalSpacing="md" verticalSpacing="sm">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>Replicas</Table.Th>
            <Table.Th>Updated</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Card>
  )
}